/**
 * @generated SignedSource<<0d00d64b06caa5b2a85550b1eefe6675>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ScrapActionEnum = "scrap_delete" | "scrap_image_update" | "scrap_task_restore" | "%future added value";
export type ScrapSourceScrapDeleteDialog_scrapQuery$variables = {
  id: string;
};
export type ScrapSourceScrapDeleteDialog_scrapQuery$data = {
  readonly scrap: {
    readonly actions: ReadonlyArray<ScrapActionEnum>;
    readonly id: string;
    readonly problemBookPage: number;
    readonly problemNumber: string;
    readonly problemPage: number;
    readonly problems: ReadonlyArray<{
      readonly id: string;
      readonly objectUrl: string;
    }>;
    readonly solutionBookPage: number;
    readonly solutionPage: number;
    readonly solutions: ReadonlyArray<{
      readonly id: string;
      readonly objectUrl: string;
    }>;
    readonly task: {
      readonly id: string;
      readonly isDeleted: boolean;
      readonly sequence: number;
    } | null;
  };
};
export type ScrapSourceScrapDeleteDialog_scrapQuery = {
  response: ScrapSourceScrapDeleteDialog_scrapQuery$data;
  variables: ScrapSourceScrapDeleteDialog_scrapQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  (v1/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "objectUrl",
    "storageKey": null
  }
],
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Scrap",
    "kind": "LinkedField",
    "name": "scrap",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "actions",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "problemPage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "solutionPage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "problemBookPage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "solutionBookPage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "problemNumber",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Task",
        "kind": "LinkedField",
        "name": "task",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sequence",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isDeleted",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "File",
        "kind": "LinkedField",
        "name": "problems",
        "plural": true,
        "selections": (v2/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "File",
        "kind": "LinkedField",
        "name": "solutions",
        "plural": true,
        "selections": (v2/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ScrapSourceScrapDeleteDialog_scrapQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ScrapSourceScrapDeleteDialog_scrapQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "7536b45fd5cae1c9364f1abd7bf5b053",
    "id": null,
    "metadata": {},
    "name": "ScrapSourceScrapDeleteDialog_scrapQuery",
    "operationKind": "query",
    "text": "query ScrapSourceScrapDeleteDialog_scrapQuery(\n  $id: ID!\n) {\n  scrap(id: $id) {\n    id\n    actions\n    problemPage\n    solutionPage\n    problemBookPage\n    solutionBookPage\n    problemNumber\n    task {\n      id\n      sequence\n      isDeleted\n    }\n    problems {\n      id\n      objectUrl\n    }\n    solutions {\n      id\n      objectUrl\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3ace17d7959c219a806f78fbd70a4b93";

export default node;
